import { css } from "@linaria/core"
import { styled } from "@linaria/react"

import { Vertical } from "@/components/Flex.ts"

export const DropdownWithFilterStyles = {
  Container: styled(Vertical)<{ offset: number, maxHeight?: number }>`
    width: 320px;
    height: ${props => `calc(${props.maxHeight ?? 360}px - ${props.offset}px)`};
  `,

  List: css`
    flex: 1;

    width: 100%;
    min-height: 0;
  `,

  Scrollable: css`
    padding: 8px 0;
  `,

  Header: styled.div`
    line-height: 24px;

    &:empty {
      display: none;
    }
  `,

  Footer: styled.div`
    line-height: 24px;

    &:empty {
      display: none;
    }
  `
}
